import React from 'react';
import { Box, CircularProgress } from '@mui/material';
import { styled } from '@mui/material/styles';

import { PROGRAMS } from '../../constants/programs';

export const TabFallback = () => (
  <Box sx={{ display: 'flex', justifyContent: 'center', py: 6 }}>
    <CircularProgress />
  </Box>
);

export const TAB_ENROLLMENT = 0;
export const TAB_SELECTIONS = 1;
export const TAB_SINGLE_API_SEARCH = 2;
export const TAB_VMT_STAGING = 3;
export const TAB_BULK_SEND = 4;
export const TAB_STATUS_CHANGES = 5;
export const TAB_HISTORICAL_TRENDS = 6;
export const TAB_SEND_HISTORY = 7;
export const TAB_ACTION_REQUIRED = 8;
export const TAB_APPSHEET_REPORTING = 9;
export const TAB_EMAILS_SENT = 10;
export const TAB_CANCELS = 11;
export const TAB_ENROLLMENT_STATUS_CHANGES = 12;

export const ALL_PROGRAMS_OPTION = 'All Programs';
export const PROGRAM_OPTIONS = [ALL_PROGRAMS_OPTION, ...PROGRAMS];

export const DrawerDragger = styled('div')(({ theme }) => ({
  width: '5px',
  cursor: 'ew-resize',
  padding: '4px 0 0',
  borderLeft: `1px solid ${theme.palette.divider}`,
  position: 'absolute',
  top: 0,
  left: 0,
  bottom: 0,
  zIndex: 100,
  backgroundColor: theme.palette.background.paper,
}));
